import {createTheme, ThemeProvider} from "@mui/material";
import React, {PropsWithChildren} from "react";

const theme = createTheme({
  palette: {
    primary: {
      main: '#E38752',
    },
    secondary: {
      main: '#965027',
    },
  },
})

const CustomThemeProvider = ({children}: PropsWithChildren) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export {CustomThemeProvider as ThemeProvider}